import { render } from "./SoldAccessories.vue?vue&type=template&id=e66e0f86"
import script from "./SoldAccessories.vue?vue&type=script&lang=js"
export * from "./SoldAccessories.vue?vue&type=script&lang=js"

import "./SoldAccessories.vue?vue&type=style&index=0&id=e66e0f86&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__